import { useCallback, useState } from 'react';

export function useValidationState<TField extends string>() {
  const [formError, setFormError] = useState<string | null>(null);
  const [fieldErrors, setFieldErrors] = useState<Partial<Record<TField, string>>>({});

  const resetValidation = useCallback(() => {
    setFormError(null);
    setFieldErrors({});
  }, []);

  const clearFieldError = useCallback((field: TField) => {
    setFormError(null);
    setFieldErrors((prev) => ({
      ...prev,
      [field]: undefined,
    }));
  }, []);

  const applyParsedValidation = useCallback((parsed: {
    fieldErrors: Partial<Record<TField, string>>;
    message: string;
  }) => {
    setFieldErrors(parsed.fieldErrors);
    setFormError(parsed.message);
  }, []);

  return {
    formError,
    setFormError,
    fieldErrors,
    setFieldErrors,
    resetValidation,
    clearFieldError,
    applyParsedValidation,
  };
}
